import React, { useState } from 'react';
import { HiOutlineHome } from 'react-icons/hi';
import { HiOutlineDevicePhoneMobile, HiOutlineChatBubbleOvalLeftEllipsis } from 'react-icons/hi2';

export default function Contact() {
    const [form, setForm] = useState({ name: "", org: "", email: "", phone: "", message: "" });
    const [errors, setErrors] = useState({});

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        let tempErrors = {};
        if (!form.name.trim()) tempErrors.name = "Full Name is required";
        if (!form.org.trim()) tempErrors.org = "Organization is required";
        if (!form.email.trim()) {
            tempErrors.email = "Email is required";
        } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email)) {
            tempErrors.email = "Email is invalid";
        }
        if (!form.phone.trim()) {
            tempErrors.phone = "Phone number is required";
        } else if (!/^\d{10,15}$/.test(form.phone.replace(/\D/g, ""))) {
            tempErrors.phone = "Phone number is invalid";
        }
        if (!form.message.trim()) tempErrors.message = "Message is required";

        setErrors(tempErrors);

        if (Object.keys(tempErrors).length > 0) {
            return;
        }

        console.log("form", form)

        // try {
        //     const response = await fetch("http://localhost:5000/send-mail", {
        //         method: "POST",
        //         headers: { "Content-Type": "application/json" },
        //         body: JSON.stringify(form),
        //     });

        //     if (!response.ok) {
        //         throw new Error("Failed to send email");
        //     }

        //     const data = await response.json();
        //     alert("Form submitted!");
        // } catch (error) {
        //     alert(`Error: ${error.message}`);
        // }

        try {
            const response = await fetch("http://particle-solar-backend.vercel.app/send-mail", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(form),
            });

            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.detail || "Failed to send email");
            }

            const data = await response.json();
            alert(data.message);
            // Optionally reset form fields here
        } catch (error) {
            alert(`Error: ${error.message}`);
        }
    };

    return (
        <section className='flex flex-col items-center'>
            <div className='py-12'>
                <p className='text-5xl font-extrabold text-center text-primary-color'>CONTACT US</p>
                <p className='text-lg text-center mt-4 text-primary-color'>Looking for reliable Solar Module Mounting Solutions? Reach out to us for top-quality solutions and expert advice.</p>
            </div>

            {/* ... Contact info cards ... */}

            <div className="w-full lg:w-[50%] bg-white shadow-md p-6 rounded-lg mt-5 md:mt-0 lg:mt-0 mb-10">
                <form onSubmit={handleSubmit}>
                    <p className="text-2xl mb-4 text-gray-600">Feel free to reach out to us!</p>
                    <div className='flex flex-row gap-4 w-full'>
                        <div className="mb-4 flex-grow">
                            <label className="block text-gray-700 text-sm font-semibold mb-1" htmlFor="name">Full Name</label>
                            <input
                                name="name"
                                value={form.name}
                                onChange={handleChange}
                                type="text"
                                className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:border-blue-500"
                            />
                            {errors.name &&
                                <span className="text-red-600 text-sm">{errors.name}</span>
                            }
                        </div>
                        <div className="mb-4 flex-grow">
                            <label className="block text-gray-700 text-sm font-semibold mb-1" htmlFor="org">Organization</label>
                            <input
                                name="org"
                                value={form.org}
                                onChange={handleChange}
                                type="text"
                                className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:border-blue-500"
                            />
                            {errors.org &&
                                <span className="text-red-600 text-sm">{errors.org}</span>
                            }
                        </div>
                    </div>

                    <div className='flex flex-row gap-4 w-full'>
                        <div className="mb-4 flex-grow">
                            <label className="block text-gray-700 text-sm font-semibold mb-1" htmlFor="email">Email</label>
                            <input
                                name="email"
                                value={form.email}
                                onChange={handleChange}
                                type="email"
                                className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:border-blue-500"
                            />
                            {errors.email &&
                                <span className="text-red-600 text-sm">{errors.email}</span>
                            }
                        </div>
                        <div className="mb-4 flex-grow">
                            <label className="block text-gray-700 text-sm font-semibold mb-1" htmlFor="phone">Phone Number</label>
                            <input
                                name="phone"
                                value={form.phone}
                                onChange={handleChange}
                                type="tel"
                                className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:border-blue-500"
                            />
                            {errors.phone &&
                                <span className="text-red-600 text-sm">{errors.phone}</span>
                            }
                        </div>
                    </div>

                    <div className="mb-4">
                        <label className="block text-gray-700 text-sm font-semibold mb-1" htmlFor="message">Message</label>
                        <textarea
                            name="message"
                            value={form.message}
                            onChange={handleChange}
                            className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:border-blue-500"
                            rows="4"
                        />
                        {errors.message &&
                            <span className="text-red-600 text-sm">{errors.message}</span>
                        }
                    </div>

                    <button type='submit' className="bg-primary-color w-full text-white px-4 py-2 rounded-lg hover:bg-opacity-80">
                        Submit
                    </button>
                </form>
            </div>

        </section>
    );
}
